import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographyBlockquoteProps } from "../types";

function TypographyBlockquote({
  as,
  asChild = false,
  className,
  ...props
}: TypographyBlockquoteProps) {
  const Component = resolveElement(asChild, as, "blockquote");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.Blockquote] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
          mt-6 pl-4
          border-l-2
          font-body italic
          ~text-base/xl
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographyBlockquote;
